import { Logger } from '../../generic/utils';
import { wrapperIdentifier } from './common';
import { useEffect } from 'react';
import { wrapperBuilder } from './build';

const console = new Logger(wrapperIdentifier);

if (console) {
  //Just for usage
}

wrapperBuilder.getCustomLogicRegisterInstance().setLogic(
  ({
    functions: { loadVinculations },
    variablesHandler: {
      variables: { masterVinculations, slaveVinculations },
      variablesSetter,
    },
    bindedContexts: { user },
  }) => {
    const userId = user && (user._id || user.id);

    useEffect(() => {
      if (userId) {
        console.log('ºº Loading vinculations');
        loadVinculations();
      } else if (!userId) {
        if (masterVinculations) {
          variablesSetter('masterVinculations')(undefined);
        }
        if (slaveVinculations) {
          variablesSetter('slaveVinculations')(undefined);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);
  }
);
